import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import storeObject from "./store";
import Routes from "./routes";

function App() {
  return (
    <Provider store={storeObject.store}>
      <PersistGate loading={null} persistor={storeObject.persistor}>
        <Router>
          <Switch>
            <Route path="/" exact>
              <Routes component={"Home"} />
            </Route>
            <Route path="/reset-password" exact>
              <Routes component={"ResetPassword"} />
            </Route>
            <Route path="/verify-email" exact>
              <Routes component={"VerifyEmail"} />
            </Route>
            <Route path="/profile" exact key="profile">
              <Routes component={"Profile"} />
            </Route>
            <Route path="/campaigns" exact>
              <Routes component={"Campaigns"} />
            </Route>
            <Route path="/privacy-policy" exact>
              <Routes component={"Privacy"} />
            </Route>
            <Route path="/terms" exact>
              <Routes component={"Terms"} />
            </Route>
            <Route path="/account" exact>
              <Routes component={"Account"} />
            </Route>
            <Route path="/campaign/:id" exact>
              <Routes component={"CampaignForm"} />
            </Route>
            <Route path="/campaign/:id/rewards" exact>
              <Routes component={"Rewards"} />
            </Route>
            <Route path="/brand/:brand_slug/campaign/:campaignID" exact>
              <Routes component={"CampaignClaim"} />
            </Route>
            <Route path="/brand/:brand_slug/reward/:reward_id/consumer/:consumer_Id/redeem" exact>
              <Routes component={"RewardClaim"} />
            </Route>
            <Route path="*" exact>
              <Routes component={"NotFound"} />
            </Route>
          </Switch>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
